import styled from 'styled-components'
import { SmallText } from '../../constants/typography'
import colors from '../../constants/colors'

export const SubTitle = styled(SmallText)`
  text-align: center;
  color: ${colors.alpha};
`
